import React, { useState } from 'react';
import { gql, useMutation } from '@apollo/client';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { FormField, FormTextArea } from '../../form';

const EDIT_TAG = gql`
    mutation EditTagDetails($id: String!, $name: String!, $description: String!) {
        Tag(id: $id) {
            setName(name: $name)
            setDescription(description: $description)
        }
    }
`;

type EditTagDialogProps = {
    tag: { id?: string | null; name?: string | null; description?: string | null; type?: string | null };
    onClose: (saved?: boolean) => void;
};

const EditTagDialog = ({ tag, onClose }: EditTagDialogProps) => {
    const [name, setName] = useState(tag.name || '');
    const [description, setDescription] = useState(tag.description || '');
    const [validationError, setValidationError] = useState('');
    const [editTag, result] = useMutation(EDIT_TAG);

    const submit = async () => {
        const normalizedName = name.trim();
        const normalizedDescription = description.trim();
        if (!tag.id || !normalizedName || !normalizedDescription) {
            setValidationError('Name and description are required.');
            return;
        }

        setValidationError('');
        try {
            await editTag({ variables: { id: tag.id, name: normalizedName, description: normalizedDescription } });
            onClose(true);
        } catch (error: any) {
            setValidationError(error?.message || 'Unable to update the tag.');
        }
    };

    return (
        <DialogBase
            title={`Edit ${tag.type || 'tag'}`}
            type="OkCancel"
            visible
            onClose={() => onClose()}
            onSubmit={submit}
            validationError={validationError}
            isLoading={result.loading}
            data-testid="EditTagDialog"
        >
            <FormField label="Name" name="name" value={name} onChange={setName} />
            <FormTextArea label="Description" name="description" value={description} onChange={setDescription} />
        </DialogBase>
    );
};

export default EditTagDialog;